// 替换https
export function replaceHttps(value, pic) {
  if (!value) return pic ? pic : 'https://minio.zykj.com/sxy-business-center/2025/03/03/39529dd9e90645138b7fa3d5f7945a1d.png';
  value = value.toString();
  return value.replace('http:', 'https:')
}